import md5 from 'js-md5'
import { nanoid } from 'nanoid'
import { UAParser } from 'ua-parser-js'

const uaParser = new UAParser()

var PaymentLog = function () {
  this.app_id = ''
  this.logdata = {
    os: '', //
    os_version: '', //
    sdk_version: 'web', //
    device: '', //
    carrier: '', //
    time_zone: '', //
    //传入的参数
    user: '',
    cg_request_id: '',
    appid: '',
    click_id: '',
    currency_code: '',
    amount: '',
    product_id: '',
    created: null,
    click_type: '',
    path: '',
    gateway: '',
    transaction_id: '',
    through_cargo: '',
    //上报时的参数
    error_msg: '',
    error_code: 1,
  }
  this.initdata = {}
}

const request = ({ url, data }) => {
  if (window.navigator.sendBeacon) {
    const result = navigator.sendBeacon(url, JSON.stringify(data))
    if (result) return result
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      mode: 'no-cors',
    })
  } else {
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      mode: 'no-cors',
    })
  }
}

/**
 * init option 参数
 *
 * {
 *  fornt_name:''//项目名称携带到sdk_version
 * }
 */

PaymentLog.prototype.init = function (option) {
  this.app_id = process.env.VUE_APP_RUM_PAYMENTLOG_APP_ID
  this.logdata.sdk_version = option.fornt_name
  this.logdata.os = uaParser.getOS().name
  this.logdata.os_version = uaParser.getOS().version
  this.logdata.device = JSON.stringify(
    {
      ...uaParser.getDevice(),
      UA: navigator.userAgent,
    },
    null,
    2
  )
  this.logdata.carrier = this.get_carrier()
  this.logdata.time_zone = this.get_time_zone()
  this.initdata = this.deepClone(this.logdata)
}

PaymentLog.prototype.report = function (event, obj) {
  var el = this.deepClone(this.logdata)
  if (typeof obj !== 'undefined' && obj !== null) {
    if (obj.msg) {
      console.log(obj.msg)
      if (typeof obj.msg === 'object' && obj.msg !== null) {
        el.error_msg = obj.msg.message ? obj.msg.message : JSON.stringify(obj.msg)
      } else {
        el.error_msg = obj.msg
      }
    }
    el.error_code = obj.code ? obj.code : 1
  }
  el.path = event

  el.created = Date.now() * 1
  el.click_type = el.click_id ? 'normal' : 'unknown'
  console.log('paymentlog-' + event)
  //console.log(el)

  try {
    request({
      url: this.getReportUrl(),
      data: el,
    })
  } catch (error) {
    console.log('PaymentLog', error)
  }
}

PaymentLog.prototype.get_time_zone = function () {
  const offset = new Date().getTimezoneOffset() // 获取当前时区与UTC时间之间的偏移量
  const sign = offset > 0 ? '-' : '+' // 判断时区符号
  const hours = Math.floor(Math.abs(offset) / 60)
    .toString()
    .padStart(2, '0') // 计算小时数并补零
  const minutes = (Math.abs(offset) % 60).toString().padStart(2, '0') // 计算分钟数并补零
  const timezone = sign + hours + ':' + minutes // 拼接时区表示形式
  return timezone
}

PaymentLog.prototype.get_carrier = function () {
  //获取网络
  var con = window.navigator.connetion
  if (con) {
    const net = {
      // 网络类型
      type: con.type,
      // 下载速度
      downlink: con.downlink,
      // 网络延时
      rtt: con.rtt,
    }
    return JSON.stringify(net)
  } else {
    return '浏览器版本过低，无法获取网络情况'
  }
}

PaymentLog.prototype.clear_properties = function () {
  this.logdata = this.deepClone(this.initdata)
}

PaymentLog.prototype.set_properties = function (obj) {
  for (let k in obj) {
    if (this.logdata.hasOwnProperty(k)) {
      this.logdata[k] = obj[k]
    }
  }
  //console.log(this.logdata);
}

PaymentLog.prototype.set_clickid = function (obj) {
  this.logdata.click_id = nanoid() + Date.now()
}

PaymentLog.prototype.getReportUrl = function () {
  const rum_app_tag = process.env.VUE_APP_RUM_PAYMENTLOG_APP_TAG
  const rum_url = process.env.VUE_APP_RUM_PAYMENTLOG_APP_URL
  const rum_appkey = process.env.VUE_APP_RUM_PAYMENTLOG_APP_KEY

  const t = Date.now().toString().substr(0, 10)
  const signature = md5(`${rum_app_tag}:${t}:${rum_appkey}`)
  return `${rum_url}/log?tag=${rum_app_tag}&timestamp=${t}&num=1&signature=${signature}`
}

PaymentLog.prototype.deepClone = function (obj) {
  if (obj === null) return null
  if (typeof obj !== 'object') return obj
  if (obj.constructor === Date) return new Date(obj)
  if (obj.constructor === RegExp) return new RegExp(obj)
  let newObj = new obj.constructor()
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      newObj[key] = this.deepClone(obj[key])
    }
  }
  return newObj
}

export default PaymentLog
